// ----------------------------------------------------------------------

export default function Button(theme) {
  const isDark = theme.palette.mode === 'dark';

  return {
    MuiButton: {
      styleOverrides: {
        textPrimary: {
          color: isDark ? theme.palette.primary.lighter : theme.palette.primary.main
        },
        outlinedPrimary: {
          ...(isDark && {
            backgroundColor: 'transparent',
            borderColor: theme.palette.primary.lighter,
            color: theme.palette.primary.lighter,
            '&:hover': {
              color: theme.palette.primary.light
            }
          })
        },
        outlinedSecondary: {
          ...(isDark && {
            backgroundColor: 'transparent',
            borderColor: theme.palette.secondary.light,
            color: theme.palette.secondary.light,
            '&:hover': {
              color: theme.palette.secondary.contrastText
            }
          })
        }
      }
    }
  };
}
